
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'HokCheckbox',
	data() {
		return {
			isChecked: false
		};
	},
	computed: {
		cursorClass() {
			return { 'cursor-not-allowed': this.disabled, 'cursor-pointer': !this.disabled };
		},
		checkboxClasses() {
			return {
				...this.cursorClass,
				checked: this.isChecked, // Boolean(this.value),
				disabled: this.disabled,
				'mb-3 block w-full typeform-checkbox': this.styling === 'typeform',
				'mb-1 inline-block': this.styling === 'white',
				'text-xs mb-2 inline-block': this.styling === 'desktop',
				'mb-4 inline-block': this.styling === 'default'
			};
		},
		containerClasses() {
			return {
				...this.cursorClass,
				'group-[.checked]:after:border group-[.checked]:after:border-color-white text-color-white border-color-white':
					this.styling === 'white',
				'group-[.checked]:after:border group-[.checked]:border-color-main after:text-color-main top-[10px] left-[12px]':
					this.styling === 'typeform',
				'group-[.checked]:after:border group-[.checked]:after:border-color-text':
					this.styling === 'desktop' || this.styling === 'default'
			};
		},
		labelClasses() {
			return {
				...this.cursorClass,
				'ml-8 text-color-white': this.styling === 'white',
				'ml-8 group-[.checked]:text-color-main group-hover:text-color-main':
					this.styling === 'desktop' || this.styling === 'default',
				'w-full min-w-[250px] group-hover:text-color-main cursor-pointer rounded-[3px] pt-[9px] pr-4 pb-[9px] pl-[42px] border border-color-text group-[.checked]:border-color-main group-[.checked]:text-color-main':
					this.styling === 'typeform'
			};
		}
	},
	created() {
		if (this.id === 'hokcheckbox') {
			console.warn('HokCheckbox without explicit id', this);
		}
		// if checked is provided, start with it
		if (this.checked !== undefined) {
			this.isChecked = this.checked;
		}
		// using value for initial state
		else {
			this.isChecked = !!this.value;
		}
	},
	updated() {
		if (this.reactive) {
			if (typeof this.value !== 'boolean' && this.checked !== undefined) {
				this.isChecked = this.checked;
			} else if (this.isChecked !== !!this.value) {
				this.isChecked = !!this.value;
			}
		}
	},
	methods: {
		toggleCheck($event) {
			if (!this.disabled) {
				if (this.checkFct && typeof this.checkFct === 'function' && !this.isChecked && $event) {
					if (!this.checkFct($event)) {
						$event.stopPropagation();
						return false;
					}
				} else if (
					this.uncheckFct &&
					typeof this.uncheckFct === 'function' &&
					this.isChecked &&
					$event
				) {
					if (!this.uncheckFct($event)) {
						$event.stopPropagation();
						return false;
					}
				}

				this.isChecked = !this.isChecked;
				this.$emit('change', this.isChecked, $event, this.value);
				this.$emit('input', this.isChecked, $event, this.value);
			}
			return false;
		}
	},
	props: {
		id: { type: String, default: 'hokcheckbox', required: true },
		name: { type: String, default: undefined },
		styling: {
			type: String,
			default: 'default',
			validator: (value: string) =>
				['default', 'typeform', 'cv', 'desktop', 'white'].includes(value)
		},
		checkFct: { type: [Boolean, Function], default: false },
		uncheckFct: { type: [Boolean, Function], default: false },
		value: { type: [Boolean, String], default: false },
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		reactive: { type: Boolean, default: false },
		checked: { type: Boolean, default: undefined }
	}
});
